const translations = {
    en: {
        events: {
            events_cards_slider: {
                title: "10% off for BW Rewards® members by entering the code BWR101",
                subtitle: "* Enter the code in the \"apply discount code\" field displayed at the end of the booking process on Musement",
                price: "from ${price} ${currency}",
                discount_price: "from ${discount_price} ${currency} for BW Rewards® members",
                free: "FREE",
                free_bwr: "FREE for BW Rewards® members",
                find_out: "FIND OUT"
            }
        }
    },
    de: {
        events: {
            events_cards_slider: {
                title: "10% Rabatt für BW Rewards®-Mitglieder durch Eingabe den Coden BWR101",
                subtitle: "* Geben Sie den Code in das Feld \"Rabattcode anwenden\" am Ende der Buchung bei Musement ein",
                price: "ab ${price} ${currency}",
                discount_price: "ab ${discount_price} ${currency} für BW Rewards® mitglieder",
                free: "FREI",
                free_bwr: "FREI für BW Rewards® mitglieder",
                find_out: "AUSFINDEN"
            }
        }
    },
    es: {
        events: {
            events_cards_slider: {
                title: "10% de descuento para miembros de BW Rewards® ingresando el código BWR101",
                subtitle: "* Ingrese el código en el campo \"aplicar código de descuento\" al final de la reserva en Musement",
                price: "desde ${price} ${currency}",
                discount_price: "desde ${discount_price} ${currency} para miembros BW Rewards® ",
                free: "GRATIS",
                free_bwr: "GRATIS para los miembros BW Rewards® ",
                find_out: "DESCUBRE"
            }
        }
    },
    fr: {
        events: {
            events_cards_slider: {
                title: "10% de réduction pour les membres BW Rewards® en entrant le code BWR101",
                subtitle: "* Entrez le code dans le champ \"appliquer le code de réduction\" à la fin de la réservation sur Musement",
                price: "de ${price} ${currency}",
                discount_price: "de ${discount_price} ${currency} pour les membres BW Rewards®",
                free: "GRATUIT",
                free_bwr: "GRATUIT pour les membres BW Rewards®",
                find_out: "DÉCOUVREZ"
            }
        }
    },
    it: {
        events: {
            events_cards_slider: {
                title: "Per i soci BW Rewards® sconto del 10% inserendo il codice BWR101",
                subtitle: "*Inserisci il codice nel campo \"applica codice sconto\" al termine della prenotazione su Musement",
                price: "da ${price} ${currency}",
                discount_price: "da ${discount_price} ${currency} per i soci BW Rewards®",
                free: "GRATIS",
                free_bwr: "GRATIS per i soci BW Rewards®",
                find_out: "SCOPRI"
            }
        }
    }
};

export default translations;


// WEBPACK FOOTER //
// ./translations/events/EventsCardsSlider.js